import { createAsyncThunk } from '@reduxjs/toolkit';
import { IRequest } from 'services/pod/types';
import { checkSecureDataRequest } from 'services/secureDataSharing';

export const ThunkCheckSecureDataRequest = createAsyncThunk<IRequest, string>(
  'secureDataSharing/checkSecureDataRequest',
  requestId => checkSecureDataRequest(requestId).then(r => r.data),
);
